/*
----------------------------
Module - mobile menu
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';
    
    fmg.mobileMenu = function () {
        
        function refresh() {
            
            if (fmg.vars.screensize > 3) {
                closeMobileMenu();
            }    
            
        }

        function setupFocusOutMobileMenu() {

            $menu.on("focusout", function(evt) {

                var $next_focused_element = $(evt.relatedTarget);
                var parent = ".mobile-menu"

                // After focusing out of menu, if something else is focused but not within the mobile menu
                // Focus back on close button
                // Ensures keyboard users don't focus on something outside of the mobile menu while the mobile menu is open.
                // Keyboard user must explicitly close the mobile menu if they wish to navigate elsewhere
                if ($next_focused_element.length && !fmg.fn.isElementWithinParent($next_focused_element, parent)) {
                    $menu_close_btn.trigger("focus");
                }

            });

        }

        function closeMobileMenuOnOutsideClick() {

            $(document).on("click", function(evt){

                var $target = $(evt.target);
                var parent = ".mobile-menu";

                if(!fmg.fn.isElementWithinParent($target, parent) && isMobileMenuOpened()) {
                    closeMobileMenu();
                }

            });

        }

        function isMobileMenuOpened() {
            return $menu.hasClass("mobile-menu--open");
        }

        function closeMobileMenu() {
            $html.removeClass("overlay-open");
            $menu.removeClass("mobile-menu--open");
            $menu_open_btn.attr("aria-expanded", "false");
        }
        
        function openMobileMenu() {
            $html.addClass("overlay-open");
            $menu.addClass("mobile-menu--open");
            $menu_open_btn.attr("aria-expanded", "true");
        }

        function mobileMenuCloseBtnClicked() {

            $menu_close_btn.on("click", function() {

                if (isMobileMenuOpened()) {
                    
                    closeMobileMenu();
                    
                    // Can only focus after CSS transition has finished
                    setTimeout(function() { 
                        $menu_open_btn.trigger("focus"); 
                    }, 325);

                }

            });

        }

        function mobileMenuOpenBtnClicked() {

            $menu_open_btn.on("click", function(evt) {

                // Don't bubble up to body to trigger closeMobileMenuOnOutsideClick()
                evt.stopPropagation();

                // If the mobile menu isn't open
                if(!isMobileMenuOpened()) {

                    openMobileMenu();
                    
                    // Can only focus after transition has finished
                    setTimeout(function() { 
                        $menu_close_btn.trigger("focus"); 
                    }, 325);
                    
                }

            });

        }

        function init() {
            mobileMenuOpenBtnClicked();
            mobileMenuCloseBtnClicked();
            closeMobileMenuOnOutsideClick();
            setupFocusOutMobileMenu();
        }

        var $html = $("html");
        var $menu = $(".mobile-menu");
        var $menu_open_btn = $(".header__nav-toggle");
        var $menu_close_btn = $menu.find(".mobile-menu__nav-toggle");
        
        return {
            init: init,
            refresh: refresh
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.mobileMenu.init();
    });

}());


